<template>
  <v-row>
      <v-col cols="12">
          <vuetify-table
            :headers="headers"
            :api-u-r-l="apiURL"
            :title="title"
            permisosEliminar="eliminar_cuenta_folios_distribuidor"
            permisosNuevoMovimiento="crear_movimiento_folios_distribuidor"
            permisosHistorial="consultar_historial_cuenta_distribuidor"
          >
          </vuetify-table>
      </v-col>
  </v-row>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
    middleware: 'auth',
    metaInfo() {
      return { title: this.$t('accountDealer') };
    },
    components: {
        VuetifyTable,
    },
    data: () => ({
      headers: [
        {
          text: 'Número de Identificación',
          value: 'identificacion',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Distribuidor',
          value: 'razonSocial',
          align: 'left',
          sortable: true,
        },
        {
          text: 'No. Cuenta',
          value: 'account_number',
          align: 'left',
          sortable: true,
        },
        {
          text: 'NIKKON',
          value: 'folios',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Cupos de Empleados',
          value: 'employees',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Estado',
          value: 'active',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          align: 'left',
          sortable: true,
        },
      ],
      name: '',
    }),
    computed: {
        apiURL() {
            return '/api/account';
        },
        title() {
        return 'Cuentas de Distribuidores';
        },
    },
    mounted() {
      if (!this.can('cambiar_estado_cuenta_distribuidor')) {
        this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
      }
      if (!this.can('eliminar_cuenta_folios_distribuidor') && !this.can('crear_movimiento_folios_distribuidor')
            && !this.can('consultar_historial_cuenta_distribuidor')) {
        this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
      }
    },
};
</script>

<style>

</style>
